import {
  MdAddCircleOutline,
  MdArrowForwardIos,
  MdRemoveCircleOutline,
} from "react-icons/md";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import PlaylistService from "services/music/PlaylistService";

import { useEffect, useState } from "react";
import { RouteName } from "constant/routeNames";
import { triggerSuccessNotification } from "utils/notification";
import { Notification } from "constant/notifications";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { IoMdShareAlt } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import MusicService from "services/music/MusicService";
import { addToQueue } from "redux/AudioPlayerRedux";

function MusicPlayListPopUpDesktop({
  className,
  list,
  openModal,
  closeModal,
  userPlaylists,
  setUserPlaylists,
  mediaId,
  removeFromPlaylist,
  setRemovedSongId,
  setOpenedComponent,
}: any) {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const { musicPlaylistId, playerVisible } = useSelector(
    (state: any) => state?.audio
  );
  const dispatch = useDispatch();
  const [hover, setHover] = useState<boolean>(false);
  const baseUrl = window.location.origin;

  const addSongToPlaylist = async (playlistId: any, playlistName: any) => {
    const data = {
      mediaId: mediaId,
      mediaType: "song",
      playlist_id: playlistId,
    };
    await PlaylistService.addSongToPlaylist(data)
      .then((response: any) => {
        if (response.data.success === true) {
          PlaylistService.getUserPlaylists().then((res) => {
            setUserPlaylists(res.data.data);

            if (musicPlaylistId === playlistId && playerVisible) {
              MusicService.getTrackDataByID(mediaId).then((res) => {
                dispatch(addToQueue(res));
              });
            }
            toast.success(`Add to ${playlistName}`);
          });
        } else {
          if (response.data.message === "Duplicated row") {
            toast.warning(`Already in the ${playlistName}`);
          } else {
            toast.error(`There is an issue when adding to ${playlistName}`);
          }
        }
        closeModal();
      })
      .catch((e: any) => {
        toast.error("An error occurred. Please try again.");
      });
  };

  const copyToClipboard = async () => {
    const currentUrl =
      baseUrl +
      RouteName.Music.replace(
        "*",
        RouteName.MusicTrack.replace(":id", mediaId)
      );
    await navigator.clipboard.writeText(currentUrl);
    triggerSuccessNotification(Notification.CopyToClipboard);
    closeModal();
  };

  const [submenuPosition, setSubmenuPosition] = useState<"left" | "right">(
    "right"
  );

  useEffect(() => {
    const popupElement = document.querySelector(".watchlist-dropdown");
    if (popupElement) {
      const popupRect = popupElement.getBoundingClientRect();
      const distanceToRight = window.innerWidth - popupRect.right;
      const distanceToLeft = popupRect.left;

      if (distanceToRight < distanceToLeft) {
        setSubmenuPosition("right");
      } else {
        setSubmenuPosition("left");
      }
    }
  }, []);

  const handleOpenPlaylist = () => {
    setOpenedComponent("createPlaylist");
    openModal();
  };

  const handleOpenShareModel = () => {
    setOpenedComponent("shareDetails");
    openModal();
  };

  const rowClass =
    "flex cursor-pointer list-none items-center justify-between gap-6 rounded-lg px-3 py-2 text-[13px] text-white/80 transition-colors hover:bg-white/5 hover:text-white";

  return (
    <div
      className={`watchlist-dropdown absolute rounded-xl border border-white/10 bg-[#15151a]/95 p-2 text-sm text-white shadow-[0_20px_60px_rgba(0,0,0,0.5)] backdrop-blur-xl ${
        className && className
      }`}
    >
      <li className={rowClass} onClick={copyToClipboard}>
        Copy Song Link
        <IoMdShareAlt />
      </li>

      {loggedInUser && (
        <div className="relative">
          <li
            className={rowClass}
            onMouseEnter={() => setHover(true)}
          >
            Add to playlist
            <MdArrowForwardIos className="text-[12px]" />
          </li>

          {/* submenu */}
          {hover && (
            <div
              className={`watchlist-dropdown scrollbar-hide absolute bottom-[-10px] max-h-[220px] !min-w-[240px] overflow-y-scroll overflow-x-visible rounded-xl border border-white/10 bg-[#15151a]/95 p-2 text-sm text-white shadow-[0_20px_60px_rgba(0,0,0,0.5)] backdrop-blur-xl ${
                submenuPosition === "right" ? "right-[235px]" : "left-[235px]"
              }`}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
              {userPlaylists?.map((item: any, i: number) => (
                <li
                  className="cursor-pointer list-none rounded-lg px-3 py-2 text-[13px] text-white/80 transition-colors hover:bg-white/5 hover:text-white"
                  key={i}
                  onClick={() => addSongToPlaylist(item?.id, item?.title)}
                >
                  {item?.title.length > 25 ? (
                    <>
                      <span data-tooltip-id={item?.id}>{`${item?.title.slice(
                        0,
                        25
                      )}...`}</span>
                      <ReactTooltip
                        className="absolute w-full text-sm"
                        id={item?.id}
                        place="top"
                        content={item?.title}
                      />
                    </>
                  ) : (
                    item?.title
                  )}
                </li>
              ))}

              {userPlaylists?.length > 0 && (
                <div className="my-1 border-t border-white/10" />
              )}

              {/* Create new playlist */}
              <li
                className="flex cursor-pointer list-none items-center gap-2 rounded-lg px-3 py-2 text-[13px] text-white/80 transition-colors hover:bg-white/5 hover:text-white"
                onClick={handleOpenPlaylist}
                onMouseEnter={() => setHover(true)}
              >
                <MdAddCircleOutline className="text-base" />
                Create new {list}
              </li>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default MusicPlayListPopUpDesktop;